export enum WorkFromHome {
  OneDay = 1,
  TwoDays = 2,
  ThreeDays = 3,
  FourDays = 4,
  AllWeek = 5,
  No = -1,
}
